import React from "react"
import styled from "styled-components"
import { devices } from "Utils/devices"

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 75px;
`

const SVG = styled.svg`
  ${({ isFromWidgetChoice }) =>
    isFromWidgetChoice &&
    `
    @media ${devices.tablet} {
      width: 60px; 
      height: 45px;
    }`}
`

const CardMSF = ({ isFromWidgetChoice }) => (
  <IconContainer>
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      isFromWidgetChoice={isFromWidgetChoice}
      x="0px"
      y="0px"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M 10.369951,1.3308432 H 4.3220609 c -0.2569361,0 -0.4652225,0.168004 -0.4652225,0.3752485 v 1.5009958 c 0,0.2072453 0.2082864,0.3752484 0.4652225,0.3752484 h 6.0478901 c 0.256927,0 0.465222,-0.1680031 0.465222,-0.3752484 V 1.7060917 c 0,-0.2072445 -0.208295,-0.3752485 -0.465222,-0.3752485 z"
        stroke="#787878"
        id="path19"
        className="strokeHoverSVG"
      />
      <path
        d="M 10.369951,4.7080825 H 4.3220609 c -0.2569361,0 -0.4652225,0.1680114 -0.4652225,0.3752489 v 1.5009953 c 0,0.2072371 0.2082864,0.375249 0.4652225,0.375249 h 6.0478901 c 0.256927,0 0.465222,-0.1680119 0.465222,-0.375249 V 5.0833314 c 0,-0.2072375 -0.208295,-0.3752489 -0.465222,-0.3752489 z"
        stroke="#787878"
        id="path21"
        className="strokeHoverSVG"
      />
      <path
        d="m 10.369951,8.0159682 h -6.04789 c -0.256936,0 -0.4652225,0.1680041 -0.4652225,0.3752485 v 1.5009961 c 0,0.2072452 0.2082865,0.3752492 0.4652225,0.3752492 h 6.04789 c 0.256927,0 0.465222,-0.168004 0.465222,-0.3752492 V 8.3912167 c 0,-0.2072444 -0.208295,-0.3752485 -0.465222,-0.3752485 z"
        stroke="#787878"
        id="path19-7"
        className="strokeHoverSVG"
      />
      <path
        d="m 10.369951,11.393208 h -6.04789 c -0.256936,0 -0.4652225,0.168012 -0.4652225,0.375249 v 1.500996 c 0,0.207237 0.2082865,0.375248 0.4652225,0.375248 h 6.04789 c 0.256927,0 0.465222,-0.168011 0.465222,-0.375248 v -1.500996 c 0,-0.207237 -0.208295,-0.375249 -0.465222,-0.375249 z"
        stroke="#787878"
        id="path21-0"
        className="strokeHoverSVG"
      />
    </SVG>
  </IconContainer>
)

export default CardMSF
